import React from "react";
import BaseFormPage from "../../../../base/BaseFormPage";
import CollectionFormPresenter from "../../../collection-form/CollectionFormPresenter";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import NavBar from "../../../../components/NavBar";
import withRouter from "../../../../withRouter";
import FormFactory from "../../../../components/FormFactory";

class PortalSettingsFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      taskObj: {},
      advanced: false,
      tasks: [],
      isTaskOpen: false,
      name: "",
      description: "",
      isTaskEmpty: false,
    };
    this.presenter = new CollectionFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase()
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.object !== this.state.object) {
      this.setState({ tasks: this.state.object.tasks });
    }
  }

  getCollectionName() {
    return "portal_settings";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onChangeObject(object) {
    this.presenter.onChangeObject(object);
  }
  handleAddTask() {
    this.setState({ isTaskOpen: true, taskObj: {}, isTaskEmpty: false });
  }
  closeTaskForm(value) {
    this.setState({ isTaskOpen: value, taskObj: {} });
  }

  async handleAddBTN() {
    await upsertUseCase().execute(this.getCollectionName(), this.state.object);
    this.showSuccess("New Portal Parameter Added");
    this.navigateBack();
  }

  addTaskData(data) {
    const { tasks } = this.state;
    if (data.index !== null && data.index !== undefined) {
      tasks[data.index] = data; // Update existing task
    } else {
      data.index = tasks.length;
      tasks.push(data); // Add new task
    }
    this.setState({
      tasks,
      isTaskOpen: false,
      taskObj: {},
    });
  }

  handleTaskDelete = (index) => {
    const tasks = [...this.state.tasks];
    tasks.splice(index, 1);
    this.setState({ tasks });
  };

  handleTaskEdit(item, index) {
    this.setState({ isTaskOpen: true, taskObj: { ...item, index } });
  }

  render() {
    const object = this.state.object;
    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "Update ";
    return (
      <>
        <div className="overflow-auto mt-5">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <div className="mt-3 bg-white shadow rounded p-3 px-lg-5 py-lg-4">
                <h1 className="fw-bold mt-2 mb-4 text-capitalize">
                  {(schema.label || this.getCollectionName()) + " Details"}
                </h1>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    this.handleAddBTN();
                  }}
                >
                  <FormFactory
                    className="pb-3"
                    schema={schema}
                    object={object}
                    onChange={this.onChange.bind(this)}
                    excludeFields={["id"]}
                  />
                  <div className="mt-4">
                    <button
                      type="submit"
                      className="btn btn-primary fs-sm me-3"
                    >
                      <i className="bi bi-file-earmark-check me-2"></i>
                      {label}
                    </button>
                    <button
                      type="button"
                      className="btn btn-light fs-sm"
                      onClick={this.onClickBack.bind(this)}
                    >
                      GO BACK
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(PortalSettingsFormPage);
